/**
 * Copyright © 2026 Farmlands Co-operative Society Limited. All rights reserved.
 *
 * This document contains confidential information and is the property of Farmlands.
 * Unauthorised reproduction or distribution of any part of this publication is prohibited without written consent.
 */

import { RouteObject } from "react-router-dom";

import { PAYMENTS_ROUTES } from "./constants";
import { PaymentsRouter } from "./PaymentsRouter";

export const paymentsRoutes: RouteObject[] = [
  { path: PAYMENTS_ROUTES.ROOT, element: <PaymentsRouter /> },
];
